import React from "react";
import { Link } from "react-router-dom";
import "./PolicyPage.css";

export default function CookiePolicy() {
  return (
    <div className="policy-page">
      <header className="policy-header">
        <div className="policy-header-inner">
          <Link to="/" className="policy-brand">
            <img src="/TechXM-logo.png" alt="TECHXM logo" className="brand-logo-mark" width="30" height="30" />
          </Link>
          <nav className="policy-nav">
            <Link to="/privacy-policy">Privacy</Link>
            <Link to="/terms-of-service">Terms</Link>
          </nav>
        </div>
      </header>

      <main className="policy-main">
        <h1 className="policy-title">Cookie Policy</h1>
        <p className="policy-effective">Effective Date: March 6, 2026</p>
        <p className="policy-intro">
          This Cookie Policy explains how TECHXM uses cookies and similar
          technologies on our website.
        </p>

        <section className="policy-section">
          <h2>What Cookies Are</h2>
          <p>
            Cookies are small text files stored on your device to help websites
            remember preferences and improve performance.
          </p>
        </section>

        <section className="policy-section">
          <h2>How We Use Cookies</h2>
          <ul>
            <li>Essential cookies for core website functionality.</li>
            <li>Analytics cookies to understand usage and improve experience.</li>
            <li>Preference cookies to remember settings when applicable.</li>
          </ul>
        </section>

        <section className="policy-section">
          <h2>Managing Cookies</h2>
          <p>
            You can manage or disable cookies in your browser settings. Some
            website features may not function as expected if cookies are
            disabled.
          </p>
        </section>

        <section className="policy-section">
          <h2>Updates</h2>
          <p>
            We may update this Cookie Policy periodically. The latest version
            will always be available on this page.
          </p>
        </section>
      </main>
    </div>
  );
}





